// request.tsx
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

/** Interfaz para el payload de Add/Update Data Center */
export interface AddDataCenterPayload {
	datacenterId: string;
	name: string;
	direction: string;
	gps: string;
	status: string;
	capacityKW: string; // se envía como string al backend
	phase: string;
	cage: string;
	rackId: string;
	rackCapacity: string;
	patchPanelODF: string;
	rackSecurityPin: string;
	visible: boolean;
	providerId: string;
	providerCode: string;
	city: string;
	displayName: string;
}

/**
 * GET /v1/dataCenters/list
 */
export function getDataCenters(token: string) {
	return axios.get(`${API_URL}/v1/dataCenters/list`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

/**
 * POST /v1/dataCenters/add
 */
export function addDataCenter(token: string, payload: AddDataCenterPayload) {
	return axios.post(`${API_URL}/v1/dataCenters/add`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

/**
 * PUT /v1/dataCenters/:id
 * Se encodifica el id en la URL, para que diagonales etc. no rompan el endpoint.
 */
export function updateDataCenter(
	token: string,
	datacenterId: string,
	payload: AddDataCenterPayload
) {
	const encodedId = encodeURIComponent(datacenterId);
	return axios.put(`${API_URL}/v1/dataCenters/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}
export function getProviderIds( token: string){
	return axios.get(`${API_URL}/v1/provider/ids-and-names`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

/**
 * DELETE /v1/dataCenters/:id
 * También encodificamos el ID.
 */
export function deleteDataCenter(token: string, datacenterId: string) {
	const encodedId = encodeURIComponent(datacenterId);
	return axios.delete(`${API_URL}/v1/dataCenters/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
